/**
 * User Service paths for notification-bell pending-approvals polling.
 * Excluded from session idle activity (see sessionApiActivity.utils).
 */
export const PendingApprovalsApiPath = {
  /**
   * Notification-bell summary GET only — terminal path segment (query/hash stripped before test).
   * Matches GET /api/v1/clinic-staff-profiles/user/{userId}/pending-approvals
   * Does not match similarly named segments (e.g. pending-approvals-archive).
   */
  SUMMARY_PATH_PATTERN: /\/clinic-staff-profiles\/user\/[^/?#]+\/pending-approvals$/,
} as const;
